import React, { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import Navigator from './components/Navigation';
import LifeTodoToggle from './components/LifeTodoToggle';
import { useMetaTags } from './utils/useMetaTags';
import './font.css';
import './style.css';

function PageStudy(props: {
  activeNav: number;
  setActiveNav: Dispatch<SetStateAction<number>>;
}) {
  useMetaTags({
    title: 'Study - Lynkim',
    description: 'Study',
    image: '/ogimage.png',
  });

  return (
    <div>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='pageTitle'>Study</div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 16px' }}>
        <Link
          to='/English'
          style={{
            display: 'inline-block',
            padding: '12px 24px',
            border: '1px solid var(--color-text-primary)',
            borderRadius: '999px',
            textDecoration: 'none',
            color: 'var(--color-text-primary)',
            fontSize: '15px',
            fontWeight: 500,
          }}
        >
          English
        </Link>
      </div>
      <LifeTodoToggle />
    </div>
  );
}

export default PageStudy;
